var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-content',{attrs:{"app":""}},[_c('v-container',{attrs:{"dark":""}},[_c('v-row',[_c('v-col',[_c('h2',{staticClass:"bc__header"},[_vm._v("Hi, tell something about yourself and the conference")])])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }